import {Component, Input, OnInit} from '@angular/core';
import {TooltipService} from '../../services/tooltip.service';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.css']
})
export class TooltipComponent implements OnInit {
  @Input() input: any;

  constructor(
    private tooltipSvc: TooltipService,
  ) { }

  ngOnInit() {
  }

	infoIconItem(labelName: string): any {
		return this.tooltipSvc.getTooltipItem(labelName);
	}
}
